
/* User defined models */
import { Slot } from './slot.model'
import { SiteLocation } from './sitelocation.model'

export class SiteSlot {
    id: string;
    uri: string;
    type: string;
    prefix: string;
    location: SiteLocation;
    slots: Slot[];
    Testdate?: any;
    availability?: string[];

  constructor(id: string,
    uri: string,
    type: string,
    prefix: string,
    location: SiteLocation,
    slots: Slot[],
    testdate?: any,
    availability?: string[]) {
    this.id = id;
    this.uri = uri;
    this.type = type;
    this.prefix = prefix;
    this.location = location;
    this.slots = slots;
    this.Testdate = testdate;
    this.availability = availability;
  }
}
